export enum InputHashtagType {
  GENERAL = 1,
  ACCOUNT = 2,
  CONTACT = 3
}
